export type SearchDraft = {
  readonly route: string;
  readonly search: string;
  readonly active: boolean;
  readonly query: string;
  readonly issued: string[];
  readonly pending: {
    readonly href: string;
  } | null;
};

export function synchronizeSearchDraft({
  draft,
  route,
  search,
  onSearchRoute,
  currentHref,
  urlQuery,
}: {
  readonly draft: SearchDraft;
  readonly route: string;
  readonly search: string;
  readonly onSearchRoute: boolean;
  readonly currentHref: string;
  readonly urlQuery: string;
}): SearchDraft {
  // A completed navigation must not overwrite typing that followed it.
  const acknowledged = onSearchRoute
    ? draft.issued.lastIndexOf(currentHref)
    : -1;
  return {
    route,
    search,
    active: draft.route === route ? draft.active : onSearchRoute,
    query: acknowledged === -1 ? urlQuery : draft.query,
    issued: acknowledged === -1 ? [] : draft.issued.slice(acknowledged + 1),
    pending: acknowledged === -1 ? null : draft.pending,
  };
}
